export default __webpack_public_path__ + "static/media/soundPack3.8218b5b5.png";